export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40f297d321f5cdf03f94025f9b3e2a7fc7e482db1b&name=revalidateCommunity!'